document.documentElement.classList.remove('no-js'); document.documentElement.classList.add('js');
/* luz.js — clon "luz" (fuente: tema Shrine PRO). Script clásico, ES2017, sin dependencias ni CDNs.
 * Reimplementa en vanilla lo que el main.js ofuscado de la fuente definía y se usa en la página (sticky-atc,
 * internal-video, product-info, product-form, cart-drawer, cart-drawer-items, cart-drawer-upsell, predictive-search,
 * quantity-input) + widgets reconstruidos (packs .luzb-*, reseñas .luzw-rv*, popup .luzw-pop) + vestido de Releasit.
 * Todos los observadores convergen (gotchas §E): comparan antes de escribir, disconnect/observe, topes por tiempo.
 */
(function () {
  'use strict';
  var html = document.documentElement;
  function fail(e) { try { html.classList.add('luz-js-failed'); if (window.console) console.error('[luz]', e); } catch (x) {} }
  window.__luzFail = fail;

  /* ---------- Aparición (Shrine: .animate-section.animate--hidden / Dawn: .scroll-trigger) ---------- */
  var APPEAR_SEL = '.animate-section.animate--hidden, .scroll-trigger.animate--slide-in, .scroll-trigger.animate--fade-in, .scroll-trigger';
  function reveal(el) {
    if (el.classList.contains('animate--hidden')) el.classList.remove('animate--hidden');
    if (el.classList.contains('scroll-trigger--offscreen')) el.classList.remove('scroll-trigger--offscreen');
  }
  function revealAll() {
    try { Array.prototype.forEach.call(document.querySelectorAll('.animate--hidden, .scroll-trigger--offscreen'), reveal); } catch (e) {}
  }
  function initAppear() {
    var els = document.querySelectorAll(APPEAR_SEL);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (el.classList.contains('scroll-trigger') && r.top > window.innerHeight && !el.classList.contains('scroll-trigger--offscreen')) el.classList.add('scroll-trigger--offscreen');
      io.observe(el);
    });
  }
  setTimeout(revealAll, 2500); /* red de seguridad: si el observer no dispara, todo visible a los 2,5 s */
  window.addEventListener('error', function () { /* un error ajeno no debe dejar contenido oculto */ setTimeout(revealAll, 0); });

  /* ---------- utilidades ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function define(name, cls) { try { if (!customElements.get(name)) customElements.define(name, cls); } catch (e) { fail(e); } }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function toggleClass(el, c, on) { if (el && el.classList.contains(c) !== !!on) el.classList.toggle(c, !!on); }
  function setAttr(el, a, v) { if (!el) return; if (v === null) { if (el.hasAttribute(a)) el.removeAttribute(a); } else if (el.getAttribute(a) !== String(v)) el.setAttribute(a, v); }
  function setHidden(el, hide) { if (!el) return; if (hide && !el.hasAttribute('hidden')) el.setAttribute('hidden', ''); if (!hide && el.hasAttribute('hidden')) el.removeAttribute('hidden'); }
  function routes() { return window.LUZ_ROUTES || {}; }
  function rootUrl(p) { var r = routes().root || '/'; if (r === '/' || !r) return p; return r.replace(/\/$/, '') + p; }
  function cartJsUrl() { return (routes().cart || rootUrl('/cart')) + '.js'; }
  function cartAddUrl() { return (routes().cart_add || rootUrl('/cart/add')) + '.js'; }
  function cartChangeUrl() { return (routes().cart_change || rootUrl('/cart/change')) + '.js'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Dinero: window.LUZ_MONEY_FORMAT (p. ej. "$ {{amount_no_decimals}}" = shop.money_format) o Intl es-MX ("$ 1,234"). */
  function fmtNum(n, dec, th, dm) {
    var fixed = (n / 100).toFixed(dec), parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return parts.length > 1 ? parts[0] + dm + parts[1] : parts[0];
  }
  function money(cents) {
    cents = parseInt(cents, 10) || 0;
    var f = window.LUZ_MONEY_FORMAT;
    if (f && /\{\{\s*\w+\s*\}\}/.test(f)) {
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        switch (k) {
          case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
          default: return fmtNum(cents, 2, ',', '.');
        }
      }).replace(/<[^>]*>/g, '');
    }
    var v = cents / 100, dec = cents % 100 === 0 ? 0 : 2;
    try { return '$ ' + v.toLocaleString('es-MX', { minimumFractionDigits: dec, maximumFractionDigits: dec }); } catch (e) { return '$ ' + fmtNum(cents, dec, ',', '.'); }
  }
  window.luzMoney = money;

  /* ======================================================================================
   * Releasit (cod-releasit.md §3/§4): host [data-luz-releasit-host] (el form #luz-product-form).
   * ====================================================================================== */
  var RSI_BTN = '._rsi-buy-now-button', RSI_SKIP = '._rsi-modal-container, ._rsi-modal-form';
  function rsiButtons(host) {
    return $$(RSI_BTN, host).filter(function (b) { return !(b.closest && b.closest(RSI_SKIP)); });
  }
  function initReleasit() {
    $$('[data-luz-releasit-host]').forEach(function (host) {
      var root = host.closest('[data-cta-bg]') || host, d = root.dataset;
      var S = {
        'background': d.ctaBg, 'background-color': d.ctaBg, 'color': d.ctaColor, 'border-radius': d.ctaRadius, 'border': d.ctaBorder || '0',
        'box-shadow': d.ctaShadow || 'none', 'font-size': d.ctaSize, 'font-weight': d.ctaWeight, 'font-family': d.ctaFont,
        'padding': d.ctaPadding, 'width': '100%', 'margin': d.ctaMargin, 'text-transform': d.ctaTransform,
        'letter-spacing': d.ctaSpacing, 'height': 'auto', 'min-height': d.ctaHeight, 'animation': 'none'
      };
      var mo = null, runs = 0, win = 0, stopped = false, OBS = { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] };
      function ownBtns() { return $$('[name="add"].luz-own-atc', host); }
      function dress() {
        if (stopped) return;
        var now = Date.now(); if (now - win > 10000) { win = now; runs = 0; }
        if (++runs > 25) { if (mo) { mo.disconnect(); mo = null; } stopped = true; return; }
        if (mo) mo.disconnect();
        try {
          var bs = rsiButtons(host);
          bs.forEach(function (b) {
            for (var k in S) { if (S[k] && b.style.getPropertyValue(k) !== S[k]) b.style.setProperty(k, S[k], 'important'); }
            if (b.classList.contains('_rsi-buy-now-button-shaker')) b.classList.remove('_rsi-buy-now-button-shaker');
            if (S.color) {
              b.querySelectorAll('svg').forEach(function (svg) { if (svg.getAttribute('fill') && svg.getAttribute('fill') !== 'none' && svg.getAttribute('fill') !== S.color) svg.setAttribute('fill', S.color); });
              b.querySelectorAll('span').forEach(function (sp) { if (sp.style.getPropertyValue('color') !== S.color) sp.style.setProperty('color', S.color, 'important'); });
            }
          });
          if (bs.length) {
            toggleClass(host, 'luz-has-cod', true); toggleClass(host, 'luz-no-cod', false);
            ownBtns().forEach(function (o) { toggleClass(o, 'luz-own-atc--off', true); });
          }
        } catch (e) {}
        if (mo) { try { mo.observe(host, OBS); } catch (e) {} }
      }
      if (window.MutationObserver) { mo = new MutationObserver(dress); }
      dress();
      if (mo && !stopped) { try { mo.observe(host, OBS); } catch (e) {} }
      [300, 1000, 2500, 5000].forEach(function (ms) { setTimeout(dress, ms); });
      window.addEventListener('load', dress);
      setTimeout(function () {
        if (!rsiButtons(host).length) {
          if (mo) { mo.disconnect(); }
          toggleClass(host, 'luz-no-cod', true);
          ownBtns().forEach(function (o) { toggleClass(o, 'luz-own-atc--off', false); });
          if (mo && !stopped) { try { mo.observe(host, OBS); } catch (e) {} }
        }
      }, 10000);
    });
  }
  window.luzOpenReleasit = function () {
    var hosts = $$('[data-luz-releasit-host]');
    for (var i = 0; i < hosts.length; i++) { var b = rsiButtons(hosts[i])[0]; if (b) { b.click(); return true; } }
    return false;
  };
  /* §4: preselecciona en el modal de Releasit la oferta del mismo índice que el pack elegido (converge en 6 s). */
  var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open', RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
  var rsiSyncing = false;
  function syncReleasit() {
    if (rsiSyncing) return; rsiSyncing = true;
    var t0 = Date.now(), done = false, mo = null, clicks = 0, last = 0;
    function finish() { done = true; rsiSyncing = false; if (mo) { mo.disconnect(); mo = null; } }
    function apply() {
      if (done) return true;
      if (!document.querySelector(RSI_MODAL)) return false;
      var offers = document.querySelectorAll(RSI_OFFER); if (!offers.length) return false;
      var el = offers[window.LUZ_SELECTED_IDX | 0]; if (!el) { finish(); return true; }
      if (el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)) { finish(); return true; }
      var target = el.querySelector('._rsi-quantity-offers-offer') || el;
      if (clicks < 6 && Date.now() - last > 250) { clicks++; last = Date.now(); try { target.click(); } catch (e) {} }
      return false;
    }
    if (apply()) return;
    if (window.MutationObserver) {
      mo = new MutationObserver(function () { if (apply()) return; if (Date.now() - t0 > 6000) finish(); });
      mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    (function poll() { if (done) return; if (apply()) return; if (Date.now() - t0 > 6000) { finish(); return; } setTimeout(poll, 150); })();
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(RSI_BTN) : null;
    if (t && t.closest('[data-luz-releasit-host]') && !t.closest(RSI_SKIP)) syncReleasit();
  }, true);

  /* ======================================================================================
   * Packs .luzb-* (contrato abajo en el informe). window.luzSelectPack(idx)
   * ====================================================================================== */
  window.LUZ_SELECTED_IDX = window.LUZ_SELECTED_IDX | 0;
  window.luzSelectPack = function (idx) {
    idx = parseInt(idx, 10) || 0;
    var cards = $$('.luzb-card'); if (!cards.length) { window.LUZ_SELECTED_IDX = idx; return; }
    var sel = null;
    cards.forEach(function (c, i) {
      var ci = c.hasAttribute('data-idx') ? parseInt(c.getAttribute('data-idx'), 10) : i;
      var on = ci === idx; if (on) sel = c;
      toggleClass(c, 'is-selected', on);
      setAttr(c, 'aria-checked', on ? 'true' : 'false');
      var r = c.querySelector('input[type="radio"]'); if (r && r.checked !== on) r.checked = on;
    });
    if (!sel) return;
    window.LUZ_SELECTED_IDX = idx;
    var q = sel.getAttribute('data-qty') || '1';
    $$('[data-luz-qty]').forEach(function (inp) { if (inp.value !== q) inp.value = q; });
    var v = sel.getAttribute('data-variant');
    if (v) $$('[data-luz-variant]').forEach(function (inp) { if (inp.value !== v) inp.value = v; });
    var p = sel.getAttribute('data-price'), cp = sel.getAttribute('data-compare');
    if (p != null) $$('[data-luz-sticky-price]').forEach(function (el) { setText(el, p); });
    if (cp != null) $$('[data-luz-sticky-compare]').forEach(function (el) { setText(el, cp); setHidden(el, !cp); });
    try { document.dispatchEvent(new CustomEvent('luz:pack', { detail: { idx: idx, qty: parseInt(q, 10) || 1 } })); } catch (e) {}
  };
  function initPacks() {
    var cards = $$('.luzb-card'); if (!cards.length) return;
    document.addEventListener('click', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('.luzb-card') : null; if (!c) return;
      if (e.target.closest('select, option')) return;
      var i = c.hasAttribute('data-idx') ? c.getAttribute('data-idx') : cards.indexOf(c);
      window.luzSelectPack(i);
    });
    document.addEventListener('change', function (e) {
      var r = e.target; if (!r || r.type !== 'radio') return;
      var c = r.closest('.luzb-card'); if (c && r.checked) window.luzSelectPack(c.hasAttribute('data-idx') ? c.getAttribute('data-idx') : cards.indexOf(c));
    });
    var pre = $('.luzb-card.is-preselected') || cards[0];
    window.luzSelectPack(pre.hasAttribute('data-idx') ? pre.getAttribute('data-idx') : 0);
  }

  /* ======================================================================================
   * Custom elements que definía main.js (mismos tags que la fuente)
   * ====================================================================================== */

  /* <sticky-atc data-after-scroll="true" data-section="…">: oculta (CSS translateY(100%)) hasta que el form principal
     sale del viewport por arriba; visible = style.transform 'none' (igual que la fuente). Pone --sticky-atc-offset en
     .scroll-to-top-btn. Su botón (#SectionAtcBtn-…/.main-product-atc) → luzOpenReleasit() o envía el form principal. */
  function mainForm() { return document.getElementById('luz-product-form') || $('[data-luz-releasit-host]') || $('product-form[data-main="true"] form'); }
  function submitMainForm() {
    var f = mainForm(); if (!f) return;
    var own = f.querySelector('[name="add"]');
    if (f.requestSubmit) { try { own ? f.requestSubmit(own) : f.requestSubmit(); return; } catch (e) {} }
    if (own) own.click(); else f.submit();
  }
  window.luzSubmitMainForm = submitMainForm;
  define('sticky-atc', class extends HTMLElement {
    connectedCallback() {
      if (this._luz) return; this._luz = true;
      var self = this;
      this.visible = null;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || !self.contains(b)) return;
        if (b.closest('.sticky-atc__button') || b.id.indexOf('SectionAtcBtn-') === 0 || b.classList.contains('main-product-atc')) {
          e.preventDefault();
          if (!window.luzOpenReleasit()) submitMainForm();
        }
      });
      if (this.getAttribute('data-after-scroll') !== 'true') { this.setVisible(true); return; }
      this.setVisible(false);
      var start = function () {
        var trg = mainForm() || document.getElementById('ProductSubmitButton-' + self.getAttribute('data-section'));
        if (!trg) { self.setVisible(true); return; }
        if (!('IntersectionObserver' in window)) { self.setVisible(true); return; }
        new IntersectionObserver(function (entries) {
          var en = entries[entries.length - 1];
          self.setVisible(!en.isIntersecting && en.boundingClientRect.bottom < 0);
        }, { threshold: 0 }).observe(trg);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
      window.addEventListener('resize', function () { if (self.visible) self.updateOffset(); });
    }
    setVisible(on) {
      if (this.visible === on) return; this.visible = on;
      var want = on ? 'none' : '';
      if (this.style.transform !== want) this.style.transform = want;
      toggleClass(this, 'sticky-atc--visible', on);
      this.updateOffset();
    }
    updateOffset() {
      var v = (this.visible ? Math.round(this.offsetHeight) : 0) + 'px';
      $$('.scroll-to-top-btn, .music-player').forEach(function (b) { if (b.style.getPropertyValue('--sticky-atc-offset') !== v) b.style.setProperty('--sticky-atc-offset', v); });
    }
  });

  /* <internal-video data-autoplay="true|false" data-action-on-inactive="none|pause">: carga <source data-src> al
     acercarse al viewport (descarta HLS si el navegador no lo reproduce), autoplay muted playsinline, botón
     .internal-video__play (play/pausa), .internal-video__sound-btn (mute), pausa fuera de pantalla y reanuda al volver. */
  define('internal-video', class extends HTMLElement {
    connectedCallback() {
      if (this._luz) return; this._luz = true;
      var self = this, v = this.querySelector('video'); this.video = v; if (!v) return;
      this.autoplay = this.getAttribute('data-autoplay') === 'true' || v.hasAttribute('autoplay');
      this.userPaused = false; this.loaded = false;
      if (this.autoplay) { v.muted = true; v.setAttribute('muted', ''); }
      v.setAttribute('playsinline', ''); v.playsInline = true;
      v.addEventListener('play', function () { toggleClass(self, 'internal-video--playing', true); });
      v.addEventListener('playing', function () { toggleClass(self, 'internal-video--loading', false); });
      v.addEventListener('pause', function () { toggleClass(self, 'internal-video--playing', false); });
      v.addEventListener('waiting', function () { toggleClass(self, 'internal-video--loading', true); });
      v.addEventListener('volumechange', function () { toggleClass(self, 'internal-video--muted', v.muted); });
      if (!v.paused) toggleClass(this, 'internal-video--playing', true); else toggleClass(this, 'internal-video--playing', false);
      toggleClass(this, 'internal-video--muted', v.muted);
      var pb = this.querySelector('.internal-video__play');
      if (pb) pb.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        self.load();
        if (v.paused) { self.userPaused = false; self.play(); } else { self.userPaused = true; v.pause(); }
      });
      var sb = this.querySelector('.internal-video__sound-btn');
      if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; if (!v.muted && v.paused) self.play(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              self.load();
              if (self.autoplay && !self.userPaused && v.paused) self.play();
            } else if (self.loaded && !v.paused && self.getAttribute('data-action-on-inactive') !== 'keep') {
              self.wasAuto = true; v.pause();
            }
          });
        }, { rootMargin: '150px 0px', threshold: 0 }).observe(this);
      } else { this.load(); if (this.autoplay) this.play(); }
    }
    load() {
      if (this.loaded) return; this.loaded = true;
      var v = this.video, changed = false, hls = v.canPlayType('application/vnd.apple.mpegurl');
      $$('source', v).forEach(function (s) {
        var ds = s.getAttribute('data-src'), type = (s.getAttribute('type') || '').toLowerCase();
        if (/mpegurl/.test(type) && !hls) { s.parentNode.removeChild(s); changed = true; return; }
        if (ds && s.getAttribute('src') !== ds) { s.setAttribute('src', ds); changed = true; }
      });
      if (v.getAttribute('data-src') && !v.getAttribute('src')) { v.setAttribute('src', v.getAttribute('data-src')); changed = true; }
      if (changed) { try { v.load(); } catch (e) {} }
    }
    play() {
      var v = this.video, p; try { p = v.play(); } catch (e) {}
      if (p && p.catch) p.catch(function () {});
    }
  });

  /* <product-info>: contenedor (sin fetch a secciones). */
  define('product-info', class extends HTMLElement {});

  /* <product-form>: si hay <cart-drawer> en la página añade por AJAX (/cart/add.js) y abre el cajón; si no, envío normal.
     El botón de Releasit lo gestiona la app (no se intercepta). */
  define('product-form', class extends HTMLElement {
    connectedCallback() {
      if (this._luz) return; this._luz = true;
      var self = this; this.form = this.querySelector('form'); if (!this.form) return;
      this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    }
    handleSubmit(e) { if (e && e.preventDefault) e.preventDefault(); if (!window.luzOpenReleasit()) submitMainForm(); }
    onSubmit(e) {
      var sub = e.submitter || null;
      if (sub && sub.closest && sub.closest(RSI_BTN)) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !window.fetch || !window.FormData) return; /* envío clásico a /cart/add */
      e.preventDefault();
      var self = this, btn = this.form.querySelector('[name="add"]'), spin = btn ? btn.querySelector('.loading-overlay__spinner') : null;
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      if (spin) spin.classList.remove('hidden');
      this.setError(null);
      var fd = new FormData(this.form);
      fetch(cartAddUrl(), { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd, credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { self.setError(res.j.description || res.j.message || (window.cartStrings && window.cartStrings.error)); return; }
          if (window.publish) window.publish('cart-update', { source: 'product-form' });
          return drawer.refresh ? drawer.refresh().then(function () { drawer.open(btn); }) : null;
        })
        .catch(function () { self.form.submit(); })
        .then(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          if (spin) spin.classList.add('hidden');
        });
    }
    setError(msg) {
      var wrap = this.querySelector('.product-form__error-message-wrapper'), m = this.querySelector('.product-form__error-message');
      if (!wrap) return;
      setHidden(wrap, !msg); if (m) setText(m, msg || '');
    }
  });

  /* <quantity-input> (Dawn) por si aparece. */
  define('quantity-input', class extends HTMLElement {
    connectedCallback() {
      if (this._luz) return; this._luz = true;
      var input = this.querySelector('input'); if (!input) return;
      this.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var step = parseInt(input.step, 10) || 1, min = parseInt(input.min, 10), max = parseInt(input.max, 10), val = parseInt(input.value, 10) || 0;
          val = b.name === 'plus' ? val + step : val - step;
          if (!isNaN(min) && val < min) val = min; if (!isNaN(max) && val > max) val = max;
          if (String(val) !== input.value) { input.value = val; input.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
    }
  });

  /* <predictive-search>: solo envío a /search?q= (sin predictivo). */
  define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      if (this._luz) return; this._luz = true;
      this.isOpen = false;
      var input = this.querySelector('input[type="search"]'), reset = this.querySelector('button[type="reset"]'), form = this.querySelector('form');
      if (form && !form.getAttribute('action')) form.setAttribute('action', routes().search || '/search');
      if (input && reset) {
        var sync = function () { toggleClass(reset, 'hidden', !input.value.trim().length); };
        input.addEventListener('input', sync);
        reset.addEventListener('click', function (e) { e.preventDefault(); input.value = ''; sync(); input.focus(); });
      }
      if (form && input) form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
    }
  });

  /* <cart-drawer> + <cart-drawer-items> + <cart-drawer-upsell>: alimentado por /cart.js y /cart/change.js. */
  define('cart-drawer-items', class extends HTMLElement {});
  define('cart-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this._luz) return; this._luz = true;
      var self = this;
      var ov = this.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
      if (ov) ov.addEventListener('click', function () { self.close(); });
      this.addEventListener('keyup', function (e) { if (e.code && e.code.toUpperCase() === 'ESCAPE') self.close(); });
      document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.code === 'Escape') && self.classList.contains('active')) self.close(); });
      this.setHeaderCartIconAccessibility();
      this.addEventListener('click', function (e) { self.onClick(e); });
      this.addEventListener('change', function (e) {
        var inp = e.target.closest('[data-luzc-qty]'); if (!inp) return;
        var line = inp.closest('[data-luzc-line]'); if (line) self.change(line.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0), line);
      });
    }
    setHeaderCartIconAccessibility() {
      var self = this, link = document.querySelector('#cart-icon-bubble');
      if (!link || link._luz) return; link._luz = true;
      link.setAttribute('role', 'button'); link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function (e) { e.preventDefault(); self.refresh(); self.open(link); });
      link.addEventListener('keydown', function (e) { if (e.code && e.code.toUpperCase() === 'SPACE') { e.preventDefault(); self.refresh(); self.open(link); } });
    }
    open(opener) {
      if (opener) this.activeElement = opener;
      var self = this;
      this.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      $$('countdown-timer', this).forEach(function (t) { if (t.playTimer) { try { t.playTimer(); } catch (e) {} } });
      this.addEventListener('transitionend', function h() {
        self.removeEventListener('transitionend', h);
        var inner = self.querySelector('.drawer__inner'), cont = self.classList.contains('is-empty') ? self.querySelector('.drawer__inner-empty') : inner;
        var focusEl = self.querySelector('.drawer__close');
        if (window.trapFocus) window.trapFocus(cont || inner, focusEl);
      });
    }
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      if (window.removeTrapFocus) window.removeTrapFocus(this.activeElement);
    }
    onClick(e) {
      var t = e.target, line = t.closest('[data-luzc-line]');
      if (!line) return;
      var key = line.getAttribute('data-key'), inp = line.querySelector('[data-luzc-qty]'), q = inp ? parseInt(inp.value, 10) || 0 : 0;
      if (t.closest('[data-luzc-remove]')) { e.preventDefault(); this.change(key, 0, line); }
      else if (t.closest('[data-luzc-plus]')) { e.preventDefault(); this.change(key, q + 1, line); }
      else if (t.closest('[data-luzc-minus]')) { e.preventDefault(); this.change(key, Math.max(0, q - 1), line); }
    }
    refresh() {
      var self = this;
      if (!window.fetch) return Promise.resolve();
      return fetch(cartJsUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); return cart; })
        .catch(function () {});
    }
    change(key, qty, line) {
      var self = this; if (line) line.classList.add('luzc-busy');
      return fetch(cartChangeUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }), credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.items) self.render(cart);
          else { self.showError((cart && (cart.description || cart.message)) || (window.cartStrings && window.cartStrings.error)); self.refresh(); }
        })
        .catch(function () { self.showError(window.cartStrings && window.cartStrings.error); })
        .then(function () { if (line) line.classList.remove('luzc-busy'); });
    }
    showError(msg) { var el = this.querySelector('#CartDrawer-CartErrors'); if (el) setText(el, msg || ''); }
    lineHtml(it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return '<div class="product-option"><dt>' + esc(o.name) + ': </dt><dd>' + esc(o.value) + '</dd></div>'; }).join('');
      var old = it.original_line_price > it.final_line_price ? '<s class="cart-item__old-price price price--end">' + esc(money(it.original_line_price)) + '</s> ' : '';
      return '<div class="cart-item cart-drawer-item luzc-line cart-item--product-' + esc(it.handle) + '" id="CartDrawer-Item-' + (i + 1) + '" data-luzc-line data-key="' + esc(it.key) + '" data-line="' + (i + 1) + '" data-variant-id="' + esc(it.variant_id) + '">'
        + '<div class="cart-item__media">' + (img ? '<a href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><img class="cart-item__image" src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="100" height="100"></a>' : '') + '</div>'
        + '<div class="cart-drawer-item__right">'
        + '<div class="cart-drawer-item__details-and-delete-btn"><div class="cart-item__details">'
        + '<a href="' + esc(it.url) + '" class="cart-item__name h4 break">' + esc(it.product_title) + '</a>'
        + (opts ? '<dl>' + opts + '</dl>' : '')
        + '</div><button type="button" class="button button--tertiary luzc-remove" data-luzc-remove aria-label="Eliminar ' + esc(it.product_title) + '">'
        + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove" width="16" height="16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1ZM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02Zm4.84 11.52h-7.5V4h7.5v9.5Z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5Zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5Z"/></svg>'
        + '</button></div>'
        + '<div class="cart-drawer-item__quantity-and-prices">'
        + '<div class="quantity luzc-qty"><button class="quantity__button" type="button" name="minus" data-luzc-minus aria-label="Reducir cantidad">&minus;</button>'
        + '<input class="quantity__input" type="number" name="updates[]" value="' + it.quantity + '" min="0" data-luzc-qty aria-label="Cantidad">'
        + '<button class="quantity__button" type="button" name="plus" data-luzc-plus aria-label="Aumentar cantidad">+</button></div>'
        + '<div class="cart-item__totals right"><div class="cart-item__price-wrapper">' + old + '<span class="price price--end cart-item__final-price">' + esc(money(it.final_line_price)) + '</span></div></div>'
        + '</div></div></div>';
    }
    render(cart) {
      if (!cart || !cart.items) return;
      var count = cart.item_count | 0, empty = count === 0, self = this;
      toggleClass(this, 'is-empty', empty);
      $$('cart-drawer-items', this).forEach(function (el) { toggleClass(el, 'is-empty', empty); });
      var box = this.querySelector('[data-luzc-items]');
      if (!box) { var host = this.querySelector('#CartDrawer-CartItems'); if (host) { box = document.createElement('div'); box.className = 'cart-items'; box.setAttribute('data-luzc-items', ''); host.appendChild(box); } }
      if (box) { var h = cart.items.map(function (it, i) { return self.lineHtml(it, i); }).join(''); if (box._luzHtml !== h) { box.innerHTML = h; box._luzHtml = h; } }
      $$('[data-luzc-count]', this).forEach(function (el) { setText(el, String(count)); });
      $$('[data-luzc-total], .cart-drawer__totals__row__money', this).forEach(function (el) { setText(el, money(cart.total_price)); });
      var saved = (cart.original_total_price | 0) - (cart.total_price | 0);
      $$('[data-luzc-savings]', this).forEach(function (el) {
        var tpl = el.getAttribute('data-template') || 'Ahorras {amount}';
        setText(el, saved > 0 ? tpl.replace('{amount}', money(saved)) : '');
      });
      var co = this.querySelector('#CartDrawer-Checkout, [name="checkout"]');
      if (co) { if (empty && !co.disabled) co.disabled = true; if (!empty && co.disabled) co.disabled = false; }
      $$('[data-luzc-progress]', this).forEach(function (pg) {
        var thr = parseInt(pg.getAttribute('data-threshold'), 10) || 0; if (!thr) return;
        var tot = cart.total_price | 0, pct = Math.min(100, Math.round(tot / thr * 1000) / 10), rem = Math.max(0, thr - tot);
        var bar = pg.querySelector('.cart-progress__bar__progress'); if (bar && bar.style.width !== pct + '%') bar.style.width = pct + '%';
        $$('[data-luzc-remaining]', pg).forEach(function (el) { setText(el, money(rem)); });
        $$('[data-luzc-progress-todo]', pg).forEach(function (el) { setHidden(el, rem === 0); });
        $$('[data-luzc-progress-done]', pg).forEach(function (el) { setHidden(el, rem > 0); });
        toggleClass(pg, 'is-complete', rem === 0);
      });
      var ids = cart.items.map(function (it) { return String(it.variant_id); });
      $$('cart-drawer-upsell', this).forEach(function (u) { setAttr(u, 'data-selected', ids.indexOf(String(u.getAttribute('data-id'))) > -1 ? 'true' : 'false'); });
      updateBubble(count);
      var live = this.querySelector('#CartDrawer-LiveRegionText'); if (live) setText(live, count + ' artículos');
    }
  });
  function updateBubble(count) {
    var link = document.querySelector('#cart-icon-bubble'); if (!link) return;
    var b = link.querySelector('.cart-count-bubble');
    var h = count > 0 ? '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' artículos</span>' : '';
    if (!b) { if (!count) return; b = document.createElement('div'); b.className = 'cart-count-bubble'; link.appendChild(b); }
    if (b.innerHTML !== h) b.innerHTML = h;
  }
  window.luzUpdateCartBubble = updateBubble;
  define('cart-drawer-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this._luz) return; this._luz = true;
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('.upsell-toggle-btn, .upsell__add-btn, .upsell__plus-btn, .upsell__checkbox, [data-luzc-upsell]');
        if (!b) return; e.preventDefault(); self.toggle();
      });
      var f = this.querySelector('form'); if (f) f.addEventListener('submit', function (e) { e.preventDefault(); self.toggle(); });
    }
    toggle() {
      if (this._busy) return; this._busy = true;
      var self = this, id = this.getAttribute('data-id'), on = this.getAttribute('data-selected') === 'true', drawer = this.closest('cart-drawer');
      var req = on
        ? fetch(cartChangeUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: String(id), quantity: 0 }), credentials: 'same-origin' })
        : fetch(cartAddUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }), credentials: 'same-origin' });
      setAttr(this, 'data-selected', on ? 'false' : 'true');
      req.then(function () { return drawer && drawer.refresh ? drawer.refresh() : null; })
        .catch(function () { setAttr(self, 'data-selected', on ? 'true' : 'false'); })
        .then(function () { self._busy = false; });
    }
  });

  /* ======================================================================================
   * Reseñas .luzw-rv* (Loox reconstruido)
   * CONTRATO para el constructor del widget de reseñas:
   *  - Raíz: .luzw-rv  (opcional data-step="7" = cuántas revela "Mostrar más"; por defecto 7)
   *  - Rejilla: .luzw-rv-grid que contiene TODOS los .luzw-rv-item (hijos directos, en el orden "destacadas").
   *    Ítems ocultos inicialmente con el atributo `hidden` (7 visibles + 23 hidden).
   *    Cada ítem: data-date="YYYY-MM-DD", data-stars="1..5", data-photo="true|false".
   *  - Masonry SIN librería (como Loox: columna más corta). luz.js añade a la rejilla la clase .luzw-rv-grid--js y crea
   *    N hijos div.luzw-rv-col donde reparte los ítems; N según el ANCHO DE LA REJILLA con los cortes del iframe de Loox
   *    (tamaño "small"): <480px → 2, 480–919px → 3, ≥920px → 4. Sobrescribible con data-cols="2,3,4" y
   *    data-bp="480,920" en .luzw-rv-grid. Sin JS (o antes de que corra) la rejilla es un bloque normal: dale en el CSS del
   *    widget un fallback (p. ej. `.luzw-rv-grid:not(.luzw-rv-grid--js){columns:2}`); el espaciado entre tarjetas va por
   *    padding del .luzw-rv-item (no uses gap en .luzw-rv-col, luz.css ya define flex column sin gap).
   *  - Botón "Mostrar más reseñas": .luzw-rv-more (dentro de la raíz). Se oculta con `hidden` al no quedar ocultos.
   *  - Tabs: .luzw-rv-tab[data-tab] (dentro de .luzw-rv-tabs) → .is-active + aria-selected; .luzw-rv-tabs[data-active].
   *  - Orden: botón .luzw-rv-filter (aria-expanded) abre/cierra .luzw-rv-sort (quita/pone `hidden` + clase .is-open);
   *    opciones [data-sort="featured|recent|rating-high|rating-low|photos"] dentro de .luzw-rv-sort → .is-chosen +
   *    aria-pressed; cierra con click fuera o Escape.
   * ====================================================================================== */
  function initReviews() {
    $$('.luzw-rv').forEach(function (root) {
      var grid = root.querySelector('.luzw-rv-grid'); if (!grid) return;
      var items = $$('.luzw-rv-item', grid), orig = items.slice();
      var step = parseInt(root.getAttribute('data-step'), 10) || 7;
      var cols = (grid.getAttribute('data-cols') || '2,3,4').split(',').map(function (x) { return parseInt(x, 10) || 2; });
      var bps = (grid.getAttribute('data-bp') || '480,920').split(',').map(function (x) { return parseInt(x, 10) || 0; });
      var colEls = [], lastW = -1, lastN = 0, relayT = null;
      function nCols(w) { var n = cols[0]; for (var i = 0; i < bps.length; i++) if (w >= bps[i]) n = cols[i + 1] || n; return n; }
      function layout(force) {
        var w = grid.clientWidth; if (!w) return;
        var n = nCols(w);
        if (!force && w === lastW && n === lastN) return;
        lastW = w; lastN = n;
        if (colEls.length !== n) {
          colEls.forEach(function (c) { if (c.parentNode === grid) grid.removeChild(c); });
          colEls = [];
          for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'luzw-rv-col'; colEls.push(c); }
        }
        toggleClass(grid, 'luzw-rv-grid--js', true);
        colEls.forEach(function (c) { if (c.parentNode !== grid) grid.appendChild(c); });
        var hs = colEls.map(function () { return 0; });
        items.forEach(function (it) {
          if (it.hidden) { if (it.parentNode !== colEls[n - 1] || it.nextSibling) colEls[n - 1].appendChild(it); return; }
          var k = 0; for (var j = 1; j < n; j++) if (hs[j] < hs[k] - 1) k = j;
          if (it.parentNode !== colEls[k] || it.nextSibling) colEls[k].appendChild(it);
          hs[k] += it.offsetHeight;
        });
      }
      function relayoutSoon() { clearTimeout(relayT); relayT = setTimeout(function () { layout(true); }, 120); }
      function visibleCount() { return items.filter(function (it) { return !it.hidden; }).length; }
      var more = root.querySelector('.luzw-rv-more');
      function syncMore() { if (more) setHidden(more, !items.some(function (it) { return it.hidden; })); }
      if (more) more.addEventListener('click', function (e) {
        e.preventDefault(); var k = 0;
        items.forEach(function (it) { if (it.hidden && k < step) { it.hidden = false; k++; } });
        layout(true); syncMore();
      });
      function sortBy(mode) {
        var K = visibleCount(), arr = orig.slice();
        function dt(it) { var t = Date.parse(it.getAttribute('data-date') || ''); return isNaN(t) ? 0 : t; }
        function st(it) { return parseFloat(it.getAttribute('data-stars')) || 0; }
        function ph(it) { var p = it.getAttribute('data-photo'); return p ? (p === 'true' ? 1 : 0) : (it.querySelector('img') ? 1 : 0); }
        if (mode === 'recent') arr.sort(function (a, b) { return dt(b) - dt(a); });
        else if (mode === 'rating-high') arr.sort(function (a, b) { return st(b) - st(a) || dt(b) - dt(a); });
        else if (mode === 'rating-low') arr.sort(function (a, b) { return st(a) - st(b) || dt(b) - dt(a); });
        else if (mode === 'photos') arr.sort(function (a, b) { return ph(b) - ph(a) || dt(b) - dt(a); });
        items = arr;
        items.forEach(function (it, i) { it.hidden = i >= K; });
        layout(true); syncMore();
      }
      var fbtn = root.querySelector('.luzw-rv-filter'), menu = root.querySelector('.luzw-rv-sort');
      function setMenu(open) { if (!menu) return; setHidden(menu, !open); toggleClass(menu, 'is-open', open); if (fbtn) setAttr(fbtn, 'aria-expanded', open ? 'true' : 'false'); }
      if (fbtn && menu) {
        setMenu(false);
        fbtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setMenu(!menu.classList.contains('is-open')); });
        menu.addEventListener('click', function (e) {
          var o = e.target.closest('[data-sort]'); if (!o) return; e.preventDefault();
          $$('[data-sort]', menu).forEach(function (x) { var on = x === o; toggleClass(x, 'is-chosen', on); setAttr(x, 'aria-pressed', on ? 'true' : 'false'); });
          sortBy(o.getAttribute('data-sort')); setMenu(false);
        });
        document.addEventListener('click', function (e) { if (menu.classList.contains('is-open') && !menu.contains(e.target) && e.target !== fbtn) setMenu(false); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
      }
      var tabs = $$('.luzw-rv-tab', root);
      tabs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          tabs.forEach(function (x) { var on = x === t; toggleClass(x, 'is-active', on); setAttr(x, 'aria-selected', on ? 'true' : 'false'); });
          var wrap = t.closest('.luzw-rv-tabs'); if (wrap && t.getAttribute('data-tab')) setAttr(wrap, 'data-active', t.getAttribute('data-tab'));
        });
      });
      $$('img', grid).forEach(function (img) { if (!img.complete) img.addEventListener('load', relayoutSoon, { once: true }); });
      try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayoutSoon); } catch (e) {}
      var rt = null; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { layout(false); }, 200); });
      layout(true); syncMore();
      root.luzLayout = function () { layout(true); };
    });
  }

  /* ======================================================================================
   * Popup .luzw-pop (Klaviyo reconstruido)
   * CONTRATO: raíz .luzw-pop con atributo `hidden` en el HTML inicial y data-delay="<segundos>" (def. 4);
   *  opcional data-open-now="true" (p. ej. si el form tiene errores) y data-storage-key (def. 'luz-pop-closed').
   *  Abrir = quitar `hidden` + clase .is-open (aria-hidden="false"). Cerrar = poner `hidden` + quitar .is-open y guardar
   *  localStorage[key]='1'. Cierran: .luzw-pop__close, .luzw-pop__no, .luzw-pop__overlay, [data-luzw-pop-close], Escape.
   *  Éxito (?customer_posted=true o contact_posted=true): se abre al instante con .is-success, quita `hidden` de
   *  .luzw-pop__ok y pone `hidden` en .luzw-pop__form.
   * ====================================================================================== */
  function initPopup() {
    $$('.luzw-pop').forEach(function (root) {
      var key = root.getAttribute('data-storage-key') || 'luz-pop-closed';
      function getFlag() { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
      function setFlag() { try { window.localStorage.setItem(key, '1'); } catch (e) {} }
      function open() { setHidden(root, false); toggleClass(root, 'is-open', true); setAttr(root, 'aria-hidden', 'false'); }
      function close() { toggleClass(root, 'is-open', false); setHidden(root, true); setAttr(root, 'aria-hidden', 'true'); setFlag(); }
      root.addEventListener('click', function (e) {
        if (e.target.closest('.luzw-pop__close, .luzw-pop__no, [data-luzw-pop-close]') || e.target.classList.contains('luzw-pop__overlay')) { e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
      var form = root.querySelector('form'); if (form) form.addEventListener('submit', function () { setFlag(); });
      var q = location.search || '';
      if (/[?&](customer_posted|contact_posted)=true/.test(q)) {
        toggleClass(root, 'is-success', true);
        setHidden(root.querySelector('.luzw-pop__ok'), false);
        setHidden(root.querySelector('.luzw-pop__form'), true);
        open(); return;
      }
      if (root.getAttribute('data-open-now') === 'true') { open(); return; }
      if (getFlag()) return;
      var delay = parseFloat(root.getAttribute('data-delay')); if (isNaN(delay)) delay = 4;
      setTimeout(function () { if (!getFlag()) open(); }, Math.max(0, delay) * 1000);
    });
  }

  /* ======================================================================================
   * Volver arriba: la sección luz-scroll-top trae su <script> inline (handleScrollToTop + visibilidad > 400 px, igual
   * que la fuente). Solo si faltara, se define aquí el mismo comportamiento.
   * ====================================================================================== */
  function initScrollTop() {
    if (typeof window.handleScrollToTop === 'function') return;
    window.handleScrollToTop = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };
    var btn = document.querySelector('.scroll-to-top-btn'); if (!btn) return;
    var ticking = false;
    function check() { ticking = false; var want = window.scrollY > 400 ? '' : 'none'; if (btn.style.display !== want) btn.style.display = want; }
    check();
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
  }

  /* ---------- arranque ---------- */
  function boot() {
    [initAppear, initReleasit, initPacks, initReviews, initPopup, initScrollTop].forEach(function (fn) { try { fn(); } catch (e) { fail(e); } });
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.refresh && location.protocol !== 'file:') drawer.refresh();
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
